import ResourceList from '../../components/ResourceList';
import React from "react";
import {toArray} from '../../util/idMap';
import {LoadLocationsEpic, ActivateLocationEpic} from '../../actions/location.actions';
import {connect} from 'react-redux'
import FlatButton from '../../components/FlatButton';
import { withRouter } from 'react-router-dom'
import {push} from 'react-router-redux';
import CircularProgress from 'material-ui/CircularProgress';
import ActivateLocationDialog from './ActivateLocationDialog';
import {Redirect} from 'react-router-dom';
import {CardActions} from 'material-ui/Card';
import ErrorBlock from '../../components/ErrorBlock';
import FontIcon from 'material-ui/FontIcon';

export class LocationList extends React.Component {

  state = {
    showActivateDialog: false,
    selectedLocation: null,
    redirectToAdd: false
  };

  constructor(props){
    super(props)
    this.onCloseActivate = this.onCloseActivate.bind(this);
    this.onSubmitActivation = this.onSubmitActivation.bind(this);
  }

  componentDidMount() {
    this.props.loadLocations(this.props.companyId);
  }

  getColumns = () => {
    return [
      {name: 'name', width: 150, label: 'Location Name'},
      {name: 'streetAddress', lable: 'Address'},
      {name: 'enabled', width: 80, label: 'Status', render: (rowData) => rowData.systemType? <span style={{color:'#ffd342', fontWeight: 'bold'}}><FontIcon className="fa fa-check-circle" color='#ffd342' style={{verticalAlign:'middle', fontSize:'1.2em'}}/> Live</span> : null},
      {name: 'posSystemType', width: 100, label: 'POS Type', render: (rowData) => rowData.systemType? rowData.systemType.posSystemType : '-'},
      {name: 'details', width: 100, label: 'Action', render: (rowData) => <span><FlatButton onClick={this.locationAction.bind(this,rowData)} style={{minHeight: 40}} labelStyle={{fontSize: 18, fontWeight: '600', textTransform: 'capitalize'}} label='Edit' primary={true}/></span>}
    ]
  }

  locationAction = (rowData) => {
    //if (!rowData.systemType){
    //  this.setState({selectedLocation: rowData._id, showActivateDialog: true});
    //} else {
      console.log('navigate to location');
      this.props.navigateLocation(rowData._id);
    //}
  }

  onCloseActivate(){
    this.setState({showActivateDialog: false});
  }

  onSubmitActivation(locationId, omnivoreId){
    this.props.activateLocation(locationId, omnivoreId);
  }

  render() {
    const textButton = {
      border: 0,
      fontSize: 16,
      fontWeight: '600',
      margin: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minWidth: 56,
      textTransform: 'capitalize',
    }
    return (
      <div className={'content-area'} style={{paddingLeft: 20,paddingRight: 20,}}>
        <CardActions>
          <FlatButton label="+ Add Restaurant Location" style={textButton} labelStyle={textButton} primary={true} onClick={()=>this.setState({redirectToAdd: true})}/>
          {this.state.redirectToAdd? <Redirect to="/location/add"/> : null }
        </CardActions>
        <ResourceList columns={this.getColumns()} data={this.props.locations} showCheckboxes={false}/>
        {this.props.error? <ErrorBlock errorText="Unable to load locations from the server at this time."/>: null}
        {this.props.loading? <div style={{textAlign: 'center'}}><CircularProgress/></div> : null }
        {this.state.showActivateDialog? <ActivateLocationDialog show={this.state.showActivateDialog} closeDialog={this.onCloseActivate} onSubmit={this.onSubmitActivation} loading={this.props.activationInProgress} activationError={this.props.activationError} location={this.props.locationsHash[this.state.selectedLocation]}/> : null}
      </div>
    );
  }
}

let mapStateToProps = ({locationsEndpoint},{match}) => ({
  locationsHash: locationsEndpoint.locations,
  locations: toArray(locationsEndpoint.locations),
  loading: locationsEndpoint.fetchInProgress,
  error: locationsEndpoint.fetchError,
  activationInProgress: locationsEndpoint.activationInProgress,
  activationError: locationsEndpoint.activationError,
  companyId: match.params.companyId,
})

let mapDispatchToProps = (dispatch) => ({
  loadLocations : (companyId) => dispatch(LoadLocationsEpic(companyId)),
  navigateLocation: (locationId) => dispatch(push(`/location/${locationId}`)),
  activateLocation: (locationId,omnivoreId) => dispatch(ActivateLocationEpic(locationId, omnivoreId))
});

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(LocationList));



// WEBPACK FOOTER //
// ./src/containers/Locations/LocationList.js